import React from 'react'
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined'
import { colors } from '@resiliatech/birdsong'
import { EmptyStateContainer, Text } from './EmptyState.styled'

export const EmptyState = () => (
  <EmptyStateContainer>
    <ChatBubbleOutlineOutlinedIcon
      sx={{ color: colors.interactive.disabledLight }}
    />
    <Text>
      As you work within the platform, you will answer questions to help track
      your progress toward impact. You can also add a new update by clicking the
      &quot;Add Update&quot; button. Your responses will be visible to your
      whole team, but only you can edit them. All responses will create an
      AI-generated update that will capture the progress made to this goal.
    </Text>
  </EmptyStateContainer>
)
